// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { connect } from 'react-redux';
import {
  getIsBonusPointDayEnabled,
  isPlacePerkEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import PlaceRewardsView from '../views/PlaceRewardsView';
import { getSiteId } from '../../../../../utils';
import { API_CONFIG } from '../../../../../services/config';
import { getBonusPointsSwitch } from '../../../../common/organisms/BonusPointsDays/container/BonusPointsDays.selectors';

const PlaceRewardsContainer = ({ isBonusPointDayEnabled, isPlacePerksEnabled, ...otherProps }) => {
  const siteId = getSiteId();
  return (
    siteId !== API_CONFIG.siteIds.ca && (
      <PlaceRewardsView
        isBonusPointDayEnabled={isBonusPointDayEnabled}
        isPlacePerkEnabled={isPlacePerksEnabled}
        {...otherProps}
      />
    )
  );
};

export const mapStateToProps = (state) => {
  return {
    isBonusPointsEnabled: getBonusPointsSwitch(state),
    isBonusPointDayEnabled: getIsBonusPointDayEnabled(state),
    isPlacePerksEnabled: isPlacePerkEnabled(state),
  };
};

export default connect(mapStateToProps)(PlaceRewardsContainer);
